import React from "react";
import styles from "../styles.module.css";
import moment from "moment";
import { formatCurrency } from "../../../../../utils/currency";
import { useWindowDimensions } from "../../../../../utils/util";
import MobileCard from "../MobileCard/MobileCard";

const BalanceTable = ({ columns, data = [], type }) => {
  const { width } = useWindowDimensions();

  return (
    <>
      {width > 769 ? (
        <table className={styles.balance_table}>
          <thead>
            <tr>
              {columns &&
                columns.map((name, i) => (
                  <th key={i}>{name}</th>
                ))}
            </tr>
          </thead>

          <tbody>
            {type === "Earnings" &&
              data.map((el) => {
                const totalPaid = Number(el?.totalAfterDiscount || el?.total || el?.itemPrice || 0);
                const platformFee = Number(el?.platformFees || 0);
                const netEarning = totalPaid - platformFee;

                return (
                  <tr key={el._id} className={styles.table_row}>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center" }}>
                        <img
                          src={el.studentId?.profilePic || "https://ui-avatars.com/api/?name=" + (el.studentId?.fullName || "Student")}
                          alt={el.studentId?.fullName}
                          style={{ width: "35px", height: "35px", borderRadius: "50%", objectFit: "cover" }}
                        />
                        <span>{el.studentId?.fullName ?? "-"}</span>
                      </div>
                    </td>
                    <td>{el.courseId?.title?.data ?? el.courseId?.title ?? "-"}</td>
                    <td>
                      {el.createdAt
                        ? moment(el.createdAt).format("D-MM-YYYY h:mm a")
                        : "-"}
                    </td>
                    <td style={{ fontSize: "0.85rem", color: "#666" }}>{el._id}</td>
                    <td style={{ fontWeight: "600" }}>{formatCurrency(totalPaid)}</td>
                    <td style={{ color: "#d9534f" }}>{formatCurrency(platformFee)}</td>
                    <td style={{ fontWeight: "700", color: "#5cb85c" }}>{formatCurrency(netEarning)}</td>
                  </tr>
                );
              })}

            {type === "Withdrawals" &&
              data.map((el) => {
                const gross = Number(el?.grossAmount || el?.withdrawalAmount || 0);
                const fee = Number(el?.platformFee || 0);
                const net = Number(el?.amount || (gross - fee));

                return (
                  <tr key={el._id} className={styles.table_row}>
                    <td style={{ fontWeight: "600" }}>{formatCurrency(gross)}</td>
                    <td style={{ color: "#d9534f" }}>{formatCurrency(fee)}</td>
                    <td style={{ fontWeight: "700", color: "#5cb85c" }}>{formatCurrency(net)}</td>
                    <td>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <span style={{
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "0.85rem",
                          backgroundColor: el?.status === "Completed" ? "#dff0d8" : el?.status === "Failed" || el?.status === "Rejected" ? "#f2dede" : "#fcf8e3",
                          color: el?.status === "Completed" ? "#3c763d" : el?.status === "Failed" || el?.status === "Rejected" ? "#a94442" : "#8a6d3b"
                        }}>
                          {el?.status || "Pending"}
                        </span>
                        {el?.status === "Completed" && el?.transactionId && (
                          <span style={{ fontSize: '10px', color: '#666', marginTop: '4px' }}>UTR: {el.transactionId}</span>
                        )}
                        {el?.status === "Completed" && el?.completedAt && (
                          <span style={{ fontSize: '9px', color: '#888' }}>
                            {moment(el.completedAt).format("D-MM-YY, h:mm a")}
                          </span>
                        )}
                        {el?.status === "Failed" && el?.failureReason && (
                          <span style={{ fontSize: '10px', color: '#d9534f', marginTop: '4px', maxWidth: '120px', textAlign: 'center' }}>
                            {el.failureReason}
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      {el.createdAt
                        ? moment(el.createdAt).format("D-MM-YYYY h:mm a")
                        : "-"}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      ) : (
        <div className="mobileWrapper">
          {data.map((el) => (
            <MobileCard key={el._id} data={el} type={type} />
          ))}
        </div>
      )}
    </>
  );
};

export default BalanceTable;
